<template>
    <div class="ur-data-grid__content ur-data-grid__content--normal" :style="contStyle" ref="content"
            @touchstart.prevent="()=>{}" @touchend.prevent="()=>{}">
        <div class="ur-data-grid__content__freeze-wrapper" :style="freezeStyle" ref="freezeWrapper"
                v-if="!!freezeWidth" @wheel="onWheelFixed">
            <freeze-row v-for="(r,i) in rows" :row="r" :key="i" :idx="i" ref="refFrzs"/>
        </div>
        <div class="ur-data-grid__content__scroll-wrapper" :style="scrollStyle" ref="scrollWrapper" @wheel="onWheelFixed">
            <template v-for="(r,i) in rows">
                <cont-row  :row="r" :key="i" :idx="i" ref="refRows"/>
                <accrd-row :row="r" :key="'acc_'+i" v-if="r.__accordion && !isVertAcc"/>
            </template>
        </div>
        <c-select :height="contentHeight" v-if="gridInfo.opts.cellMode"/>
        <!-- Vertical accordion -->
        <accrd-row :row="gridInfo.vars_accordionRow" vertical v-if="gridInfo.vars_accordionRow && isVertAcc"/>
        <!-- Pseudo scroll, please check also 'WrapperMixin' -->
        <p-scroll @on-scroll="onPseudoScroll" ref="pScroll" @adjust-scroll="setScrollLeft"/>
        <!-- anchro for tooltip -->
        <t-anchor/>
    </div>
</template>


<script>
//[IMPORT] Child components
import contRow       from '../row/urDataGridContentRow.vue';
import freezeRow     from '../row/urDataGridContentFreezeRow.vue';
import accrdRow      from '../row/urDataGridContentAccordionRow.js';
//[IMPORT] Sub components
import pScroll from './sub/urDataGridContentPseudoScroll.vue';
import cSelect from './sub/urDataGridContentCellSelect.vue';
import tAnchor from './sub/urDataGridContentTooltipAnchor.vue';
//[IMPORT] Util function
import wrapperMixin from './mixin/urDataGridContentWrapperMixin';
import {copyObj} from '../../util';

export default {
    name : "urDataGridContentNormal",
    inject : ['gridInfo'],
    mixins : [wrapperMixin],
    components : {contRow, freezeRow, accrdRow, pScroll, cSelect, tAnchor},
    data() {return {
        rows : []
    }},
    computed : {

        freezeWidth() {
            this.$nextTick(()=>{
                // freeze 보이기 여부에 따라 freezeWrapper를 다시 설정해주어야만 scroll이 먹음.
                // 안 할 경우 div의 부모가 없어 scroolTop 을 줘도 먹지가 않음
                this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
            })
            return this.gridInfo.vars_freezeWidth
        },
        scrollStyle()   {return {
            "width"      :`calc(100% - ${this.freezeWidth}px)`,
            "margin-left":`${this.freezeWidth}px`
        }},
        contentHeight() { // WARNING -> 다른 옵션들 들어가면 이게 틀릴수 있음
            return this.gridInfo.vars_viewSize*this.gridInfo.opts.rowHeight
        },
        freezeStyle() {return {width:this.freezeWidth+'px'}},
        isVertAcc() {return this.gridInfo.vars_accordionVert},
    },
    watch: {
        "gridInfo.updated" : {immediate: true, handler(v, w) {
            // 1. copy to local array & object
            this.copyFromData()
            this.forceRender();
        }},
    },
    mounted() {
        this.gridInfo.func.setRefs('content'      ,this.$refs.content);
        this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
        this.gridInfo.func.setRefs('scrollWrapper',this.$refs.scrollWrapper);
    },
    methods: {
        copyFromData(v) {
            // 1. prepare data
            var ori = this.gridInfo.data;
            // 2. copy from ori -> Prevent reactive
            this.rows = !ori ? [] : ori.map(r=> {
                var clone = copyObj(r);
                r.__compo = clone
                return clone; 
            });/**/
        }
    }
}
</script>